module.exports = __webpack_public_path__ + "img/dolce.943ac1d6.jpg";